/**
 * Browser-level error events that are noise rather than failures.
 *
 * `ResizeObserver loop ...` is reported by the browser whenever an observer
 * callback resizes the page again within the same frame. The browser skips the
 * remaining notifications and delivers them on the next frame, so nothing is
 * broken - but it surfaces as an uncaught `window.onerror` event (with a `null`
 * error). Embedded in an iframe, resizing the host page triggers it, and it
 * must not send the dashboard to the error page.
 */
const BENIGN_ERROR_MESSAGES = ['ResizeObserver loop completed with undelivered notifications', 'ResizeObserver loop limit exceeded'];

export function isBenignBrowserError(message?: string | null): boolean {
  if (!message) return false;
  return BENIGN_ERROR_MESSAGES.some((benign) => message.includes(benign));
}
